// extracted by mini-css-extract-plugin
module.exports = {"date":"capacityGasSliding_date__1IHaw"};